import { RX0005 } from "../rxTypeCode";

export const SET_ORIGINATORID = "SET_ORIGINATORID" + RX0005;
export const SET_ORIGINATORNAME = "SET_ORIGINATORNAME" + RX0005;
export const SET_SEARCHSTRING = "SET_SEARCHSTRING" + RX0005;

export const FETCH_ORIGINATORS_REQUEST = "FETCH_ORIGINATORS_REQUEST" + RX0005;
export const FETCH_ORIGINATORS_SUCCESS = "FETCH_ORIGINATORS_SUCCESS" + RX0005;
export const FETCH_ORIGINATORS_FAILURE = "FETCH_ORIGINATORS_FAILURE" + RX0005;
export const CLEANUP = "CLEANUP" + RX0005;
